export const categoryAnalysis = {
  "universities": [
    {
      "name": "Warwick Business School (YOU)",
      "composite_score": 75,
      "category_scores": [
        70,
        75,
        80,
        65,
        70,
        75,
        60,
        55,
        70
      ],
      "is_your_brand": true
    },
    {
      "name": "University of Oxford",
      "composite_score": 95,
      "category_scores": [
        92,
        98,
        94,
        89,
        85,
        93,
        88,
        86,
        84
      ],
      "is_your_brand": false
    },
    {
      "name": "London Business School",
      "composite_score": 92,
      "category_scores": [
        90,
        97,
        89,
        87,
        82,
        91,
        86,
        85,
        83
      ],
      "is_your_brand": false
    }
  ],
  "chart_data": {
    "composite_score": {
      "value": 85,
      "label": "Warwick Business School",
      "color": "blue",
      "brand": "Warwick"
    },
    "ai_category_insights": {
      "title": "AI Category Insights by Subject Area",
      "type": "combo-chart-v2",
      "x_axis": [
        "Arts, Humanities & Social Sciences",
        "Business & Management",
        "STEM",
        "Health & Medical Sciences",
        "Education & Training",
        "Law, Legal & Public Services",
        "Creative Arts & Design",
        "Hospitality, Tourism",
        "Agriculture & Environmental Studies"
      ],
      "series": [
        {
          "name": "Warwick Business School (YOU)",
          "type": "line",
          "data": [
            70,
            75,
            80,
            65,
            70,
            75,
            60,
            55,
            70
          ]
        },
        {
          "name": "University of Oxford",
          "type": "line",
          "data": [
            92,
            98,
            94,
            89,
            85,
            93,
            88,
            86,
            84
          ]
        },
        {
          "name": "London Business School",
          "type": "line",
          "data": [
            90,
            97,
            89,
            87,
            82,
            91,
            86,
            85,
            83
          ]
        }
      ]
    },
    "ai_table_summary": {
      "title": "AI Visibility Table by Category",
      "headers": [
        "Category",
        "Score"
      ],
      "rows": [
        [
          "Arts, Humanities & Social Sciences",
          82
        ],
        [
          "Business & Management",
          90
        ],
        [
          "STEM",
          78
        ],
        [
          "Health & Medical Sciences",
          75
        ],
        [
          "Education & Training",
          80
        ],
        [
          "Law, Legal & Public Services",
          83
        ],
        [
          "Creative Arts & Design",
          77
        ],
        [
          "Hospitality, Tourism & Services",
          74
        ],
        [
          "Agriculture & Environmental Studies",
          79
        ]
      ]
    },
    "category_demand": {
      "title": "Category AI Performance (Demanding Categories)",
      "type": "combo-chart-v2",
      "series": [
        {
          "name": "Arts, Humanities & Social Sciences",
          "value": 82,
          "rate": 1.5,
          "forecast": 85
        },
        {
          "name": "Creative Arts & Design",
          "value": 77,
          "rate": 1.2,
          "forecast": 80
        },
        {
          "name": "Hospitality, Tourism",
          "value": 74,
          "rate": 1.0,
          "forecast": 76
        },
        {
          "name": "Agriculture & Environmental Studies",
          "value": 79,
          "rate": 1.3,
          "forecast": 82
        }
      ]
    },
    "subject_demand_analysis": {
      "title": "Subject Demand Analysis",
      "type": "combo-chart-v2",
      "series": [
        {
          "name": "Warwick Business School (YOU)",
          "data": {
            "Teaching Quality": 75,
            "Academic Reputation": 80,
            "Placement rate": 70,
            "International Outlook": 85,
            "Resources & Infrastructure": 75,
            "Industry & Knowledge Transfer": 80,
            "AI mention": 85,
            "AI Sentiment": 75,
            "AI cited domains": 80,
            "AI page Index": 75,
            "Domestic course fees": "£9,000",
            "International course fees": "£15,000",
            "Average salary": "£28,000"
          }
        },
        {
          "name": "University of Oxford",
          "data": {
            "Teaching Quality": 75,
            "Academic Reputation": 80,
            "Placement rate": 70,
            "International Outlook": 85,
            "Resources & Infrastructure": 75,
            "Industry & Knowledge Transfer": 80,
            "AI mention": 85,
            "AI Sentiment": 75,
            "AI cited domains": 80,
            "AI page Index": 75,
            "Domestic course fees": "£9,000",
            "International course fees": "£15,000",
            "Average salary": "£28,000"
          }
        },
        {
          "name": "London Business School",
          "data": {
            "Teaching Quality": 75,
            "Academic Reputation": 80,
            "Placement rate": 70,
            "International Outlook": 85,
            "Resources & Infrastructure": 75,
            "Industry & Knowledge Transfer": 80,
            "AI mention": 85,
            "AI Sentiment": 75,
            "AI cited domains": 80,
            "AI page Index": 75,
            "Domestic course fees": "£9,000",
            "International course fees": "£15,000",
            "Average salary": "£28,000"
          }
        }
      ]
    },
    "university_info": {
      "academic_reputation": 90,
      "domestic_employment_demand": 85,
      "international_student_sentiment": 83,
      "domestic_course_fees": 45000,
      "international_employment_demand": 82,
      "placement_rate": 85,
      "international_course_fees": 63000,
      "average_salary": 80000,
      "prediction_next_5y": "Steady growth in AI-related fields and strong international presence"
    },
    "recommendations": {
      "strengths": [
        "Strong industry connections",
        "High academic reputation"
      ],
      "weaknesses": [
        "Limited focus on STEM",
        "Higher domestic fees compared to competitors"
      ]
    },
    "citations": [
      {
        "source": "QS World University Rankings",
        "url": "https://www.topuniversities.com/university-rankings/business-masters-rankings/mba/2025",
        "title": "Top MBA Programs in UK 2025 - QS World University Rankings",
        "snippet": "QS World University Rankings for MBA programs in the UK 2025, featuring top institutions like Oxford, Cambridge, and London Business School with comprehensive program details.",
        "confidence": 0.7,
        "category": "rankings"
      },
      {
        "source": "Financial Times",
        "url": "https://rankings.ft.com/businessschoolrankings/global-mba-ranking-2025",
        "title": "Financial Times MBA Rankings 2025 - UK Business Schools",
        "snippet": "Financial Times annual MBA rankings 2025 including UK business schools with employment rates, salary data, and career outcomes for graduates.",
        "confidence": 0.7,
        "category": "rankings"
      },
      {
        "source": "Complete University Guide",
        "url": "https://www.thecompleteuniversityguide.co.uk/league-tables/rankings",
        "title": "Complete University Guide - MBA Rankings UK",
        "snippet": "Comprehensive university rankings and guides for MBA programs in the UK, including admission requirements and program comparisons.",
        "confidence": 0.7,
        "category": "rankings"
      }
    ]
  },
  "context": {
    "analysis_type": "category_analysis",
    "total_universities": 3,
    "course": "MBA",
    "country": "UK",
    "analysis_timestamp": "2025-09-16T15:16:11.778057"
  },
  "timestamp": "2025-09-16T15:16:11.778257",
  "model_meta": {
    "model_version": "category_analysis_v2_ai",
    "processing_time": 40.77104878425598,
    "data_sources": [
      "ai_analysis",
      "web_search"
    ],
    "web_search_used": true,
    "universities_analyzed": 3
  }
};
